import { X } from "lucide-react";
import { useId } from "react";
import { type FieldValues, type UseFormRegister, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Input } from "~/components/ui";

interface SelectOptionFormInputProps<F extends FieldValues> {
  register: UseFormRegister<F>;
  basePath: string;
  index: number;
  onRemove: (index: number) => void;
}

export function SelectOptionFormInput<F extends FieldValues>({
  register,
  basePath,
  index,
  onRemove,
}: SelectOptionFormInputProps<F>) {
  const { t } = useTranslation();
  const { getFieldState, formState } = useFormContext();
  const valueId = useId();
  const labelJaId = useId();
  const valueError = getFieldState(`${basePath}.${index}.value`, formState).error;
  return (
    <div className="mt-2 flex items-end gap-2 rounded-md border border-border-default bg-bg-subtle p-2.5">
      <div className="flex-1">
        <label htmlFor={valueId} className="mb-1 block text-[12px] font-medium text-fg-2">
          {t("model.propertySchema.selectOptions.value")}
        </label>
        <Input id={valueId} {...register(`${basePath}.${index}.value` as never)} required />
        {valueError && <p className="mt-1 text-12-medium text-danger">{valueError.message}</p>}
      </div>
      <div className="flex-1">
        <label htmlFor={labelJaId} className="mb-1 block text-[12px] font-medium text-fg-2">
          {t("model.propertySchema.selectOptions.label.ja")}
        </label>
        <Input id={labelJaId} {...register(`${basePath}.${index}.label.ja` as never)} />
      </div>
      <Button type="button" variant="outline" size="icon" onClick={() => onRemove(index)} aria-label={t("ui.delete")}>
        <X />
      </Button>
    </div>
  );
}
